import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Router basename={process.env.REACT_APP_HOME_PAGE}>
      <App />
    </Router>
);


reportWebVitals();
